import { Controller } from "@hotwired/stimulus"

function stripAccountSearchFormKey(key) {
  if (key === "q" || key === "button") return true
  if (key === "include_soft_deleted" || key === "include_owner_admin" || key === "include_owner_user") return true
  if (key === "filters" || key.startsWith("filters[")) return true
  return false
}

// Native <input type="search"> clear (X): WebKit/Chromium may fire `search` before the value clears—defer with a macrotask.
// Rebuild the URL like the Clear link: keep limit/sort/direction, drop q and all filter-related fields.
export default class extends Controller {
  static targets = ["queryInput"]

  clearNativeSearch(_event) {
    if (!this.hasQueryInputTarget) return

    const input = this.queryInputTarget

    setTimeout(() => {
      if (input.value !== "") return

      this.showAdminSpinner()

      const form = input.form
      if (!form) return

      const url = new URL(form.action, window.location.origin)
      url.search = ""

      for (const [key, value] of new FormData(form).entries()) {
        if (stripAccountSearchFormKey(key)) continue
        if (value === "") continue
        url.searchParams.append(key, value)
      }

      const path = `${url.pathname}${url.search}`
      const link = document.createElement("a")
      link.href = path
      link.setAttribute("data-turbo-frame", "index_results")
      link.setAttribute("data-turbo-action", "advance")
      link.classList.add("hidden")
      document.body.appendChild(link)
      link.click()
      link.remove()
    }, 0)
  }

  showAdminSpinner() {
    const adminRoot = document.getElementById("admin-dashboard-root")
    if (!adminRoot) return

    const adminSpinner = this.application.getControllerForElementAndIdentifier(adminRoot, "spinner-overlay")
    adminSpinner?.show()
  }
}
